<template>
  <div class="desktop-download">
    <v-btn
      rounded="xl"
      size="large"
      variant="tonal"
      color="orange-darken-2"
      class="desktop-download-trigger"
      @click="dialogVisible = true"
    >
      <v-icon start icon="mdi-monitor-arrow-down" />
      <span>桌面端</span>
    </v-btn>

    <v-dialog v-model="dialogVisible" max-width="620">
      <v-card class="download-dialog">
        <v-card-title class="download-title">
          下载彩思笔记
          <v-btn
            icon="mdi-close"
            variant="text"
            size="small"
            aria-label="关闭"
            @click="dialogVisible = false"
          />
        </v-card-title>

        <v-card-text>
          <div class="download-version">桌面版当前稳定版本</div>
          <div class="download-options">
            <a
              v-for="item in desktopDownloads"
              :key="item.id"
              class="download-option"
              :class="{ recommended: item.id === recommendedDownloadId }"
              :href="item.url"
              @click="dialogVisible = false"
            >
              <v-icon :icon="item.icon" size="30" class="download-icon" />
              <span class="download-copy">
                <strong>{{ item.title }}</strong>
                <small>{{ item.description }}</small>
              </span>
              <span v-if="item.id === recommendedDownloadId" class="recommended-label">推荐</span>
              <v-icon v-else icon="mdi-download" size="20" />
            </a>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'

const dialogVisible = ref(false)

const desktopDownloads = [
  {
    id: 'macos-universal',
    title: 'macOS Universal',
    description: '支持 Apple Silicon 与 Intel Mac',
    icon: 'mdi-apple',
    url: '/files/pdfnote-macos-universal.dmg',
  },
  {
    id: 'windows-x64',
    title: 'Windows x64',
    description: '适用于大多数 Intel / AMD 电脑',
    icon: 'mdi-microsoft-windows',
    url: '/files/pdfnote-windows-x64.exe',
  },
  {
    id: 'windows-arm64',
    title: 'Windows ARM64',
    description: '适用于骁龙等 ARM Windows 电脑',
    icon: 'mdi-microsoft-windows',
    url: '/files/pdfnote-windows-arm64.exe',
  },
]

const recommendedDownloadId = computed(() => {
  const platform = navigator.userAgent.toLowerCase()
  if (platform.includes('mac')) return 'macos-universal'
  if (platform.includes('win')) return 'windows-x64'
  return ''
})
</script>

<style scoped>
.desktop-download {
  display: flex;
}

.desktop-download-trigger {
  min-width: 160px;
}

.download-dialog {
  border-radius: 8px;
}

.download-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 22px 8px;
  font-size: 1.3rem;
  font-weight: 700;
}

.download-version {
  margin-bottom: 14px;
  color: #6b7280;
  font-size: 0.9rem;
}

.download-options {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 10px;
}

.download-option {
  min-height: 76px;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 12px 14px;
  color: #263238;
  text-decoration: none;
  border: 1px solid #d9dee3;
  border-radius: 8px;
  background: #fff;
  transition: border-color 0.2s ease, background-color 0.2s ease;
}

.download-option:hover,
.download-option.recommended {
  border-color: #2d85f0;
  background: #f3f8ff;
}

.download-icon {
  flex: 0 0 auto;
}

.download-copy {
  min-width: 0;
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 3px;
}

.download-copy strong,
.download-copy small {
  overflow-wrap: anywhere;
}

.download-copy small {
  color: #6b7280;
  line-height: 1.35;
}

.recommended-label {
  flex: 0 0 auto;
  padding: 3px 7px;
  color: #1769c2;
  font-size: 0.75rem;
  border-radius: 6px;
  background: #e2efff;
}

@media (max-width: 600px) {
  .desktop-download,
  .desktop-download-trigger {
    width: 100%;
  }

  .download-options {
    grid-template-columns: 1fr;
  }

  .download-title {
    padding: 16px 16px 6px;
  }
}
</style>
